import {
  Button,
  Flex,
  JaneGoldIcon,
  Link,
  PoweredByAeropayLogo,
  Typography,
} from '@iheartjane/reefer';

export interface JaneGoldPromptScreenProps {
  /** Whether to hide the Jane Pay branding */
  hideJanePayBranding?: boolean;

  /** Function called when the user continues to the next screen */
  onContinue: () => void;

  /** Function called when the user requests to close the modal */
  onRequestClose: () => void;
}

export const JaneGoldPromptScreen = ({
  hideJanePayBranding,
  onContinue,
  onRequestClose,
}: JaneGoldPromptScreenProps) => {
  const textContent = `Linking your bank account will let you join Jane Gold, Jane's cash
  back rewards program${
    hideJanePayBranding ? '.' : ', and checkout quickly with Jane Pay.'
  }`;

  return (
    <Flex flexDirection="column" alignItems="center" gap={24}>
      <JaneGoldIcon size="xxl" />
      <Flex flexDirection="column" alignItems="center" gap={8} width="100%">
        <Typography variant="h2-semibold" branded textAlign="center">
          Earn cash back and shop faster
        </Typography>
        <Typography textAlign="center">{textContent}</Typography>
      </Flex>
      <Flex flexDirection="column" alignItems="center" gap={16} width="100%">
        <Button
          variant="primary"
          branded
          label="Link bank account"
          full
          onClick={() => {
            onContinue();
          }}
        />
        <Button
          variant="secondary"
          branded
          label="Not now"
          full
          onClick={() => {
            onRequestClose();
          }}
        />
      </Flex>
      <Flex flexDirection="column" alignItems="center" gap={8} width="100%">
        <Typography
          variant="small-body-regular"
          color="grays-mid"
          textAlign="center"
          mb={8}
        >
          By agreeing to link your bank, you agree to Aeropay's{' '}
          <Link
            href="https://www.aeropay.com/legal/terms-of-service"
            color="grays-mid"
          >
            Terms of Service
          </Link>{' '}
          and{' '}
          <Link
            href="https://www.aeropay.com/legal/privacy-policy"
            color="grays-mid"
          >
            Privacy Policy
          </Link>
        </Typography>
        <PoweredByAeropayLogo height={24} />
      </Flex>
    </Flex>
  );
};
